import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PurchaseOrders_ds_get_orderline_details_by_orderidService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { orderId?: number }): 
  Promise<{ result: { OrderId?: number, LineNumber?: number, MaterialId?: number, material_details?: { Id?: number, Description?: string, LookupCode?: string, Name?: string }, totals?: { TotalActualPackagedAmount?: number, ExpectedAmount?: number, OrderId?: number, OrderLineNumber?: number }, task_details?: { Id?: number, ActualPackagedAmount?: number, ActualTargetLicensePlateId?: number, ExpectedPackagedAmount?: number, LotId?: number, MaterialId?: number, OrderId?: number, OrderLineNumber?: number, ShipmentId?: number, ShipmentLineId?: number, StatusId?: number, VendorLotId?: number, Material?: { Id?: number, Description?: string, LookupCode?: string }, Lot?: { Id?: number, LookupCode?: string, VendorLot?: { Id?: number, ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string } }, ActualTargetLicensePlate?: { Id?: number, LookupCode?: string } }[], aggregate_details?: { TotalActualPackagedAmount?: number, ActualTargetLicensePlateId?: number, LotId?: number, OrderLineNumber?: number, OrderId?: number, OperationCodeId?: number, StatusId?: number, Lot?: { LookupCode?: string }, VendorLot?: { ExpirationDate?: string }, ActualTargetLicensePlate?: { LookupCode?: string }, Material?: { ControllerTypeId?: number } }[] }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { orderId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { OrderId?: number, LineNumber?: number, MaterialId?: number, material_details?: { Id?: number, Description?: string, LookupCode?: string, Name?: string }, totals?: { TotalActualPackagedAmount?: number, ExpectedAmount?: number, OrderId?: number, OrderLineNumber?: number }, task_details?: { Id?: number, ActualPackagedAmount?: number, ActualTargetLicensePlateId?: number, ExpectedPackagedAmount?: number, LotId?: number, MaterialId?: number, OrderId?: number, OrderLineNumber?: number, ShipmentId?: number, ShipmentLineId?: number, StatusId?: number, VendorLotId?: number, Material?: { Id?: number, Description?: string, LookupCode?: string }, Lot?: { Id?: number, LookupCode?: string, VendorLot?: { Id?: number, ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string } }, ActualTargetLicensePlate?: { Id?: number, LookupCode?: string } }[], aggregate_details?: { TotalActualPackagedAmount?: number, ActualTargetLicensePlateId?: number, LotId?: number, OrderLineNumber?: number, OrderId?: number, OperationCodeId?: number, StatusId?: number, Lot?: { LookupCode?: string }, VendorLot?: { ExpirationDate?: string }, ActualTargetLicensePlate?: { LookupCode?: string }, Material?: { ControllerTypeId?: number } }[] }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { orderId?: number, $keys: { OrderId?: number, LineNumber?: number, MaterialId?: number }[] }): 
  Promise<{ result: { OrderId?: number, LineNumber?: number, MaterialId?: number, material_details?: { Id?: number, Description?: string, LookupCode?: string, Name?: string }, totals?: { TotalActualPackagedAmount?: number, ExpectedAmount?: number, OrderId?: number, OrderLineNumber?: number }, task_details?: { Id?: number, ActualPackagedAmount?: number, ActualTargetLicensePlateId?: number, ExpectedPackagedAmount?: number, LotId?: number, MaterialId?: number, OrderId?: number, OrderLineNumber?: number, ShipmentId?: number, ShipmentLineId?: number, StatusId?: number, VendorLotId?: number, Material?: { Id?: number, Description?: string, LookupCode?: string }, Lot?: { Id?: number, LookupCode?: string, VendorLot?: { Id?: number, ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string } }, ActualTargetLicensePlate?: { Id?: number, LookupCode?: string } }[], aggregate_details?: { TotalActualPackagedAmount?: number, ActualTargetLicensePlateId?: number, LotId?: number, OrderLineNumber?: number, OrderId?: number, OperationCodeId?: number, StatusId?: number, Lot?: { LookupCode?: string }, VendorLot?: { ExpirationDate?: string }, ActualTargetLicensePlate?: { LookupCode?: string }, Material?: { ControllerTypeId?: number } }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      orderId?: number    }) {
      return false;
    }
}
